'use memo';

import dayjs from 'dayjs';
import {
  addSpaceBetweenCamelCase,
  AgxBadge,
  AgxBadgeType,
  ContractDetailModel,
  formatCurrency,
  Images,
  NswContractStage,
  QldContractStage,
} from '@urbanx/agx-ui-components';
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { getBuyerNames } from 'pages/contracts/components/buyers-details/BuyersHelper';
import { getContractStageBadgeType } from 'pages/contracts/contractStageBadge';

interface ContractSectionHeaderProps {
  contract: ContractDetailModel;
}

const ContractSectionHeader = ({ contract }: ContractSectionHeaderProps) => {
  const buyerNames = getBuyerNames(contract.buyers);
  const contractStage = addSpaceBetweenCamelCase(contract.contractStage);

  return (
    <section>
      <AgxSpacer
        direction="vertical"
        gap="spacing-lg"
        style={{ alignSelf: 'flex-start', width: '100%' }}
      >
        <AgxSpacer direction="horizontal" contentAlignment="center" gap="spacing-lg">
          <AgxSpacer
            direction="horizontal"
            contentAlignment="center"
            contentJustification="center"
            flexShrink={0}
            style={{
              width: 72,
              height: 72,
              borderRadius: 12,
              background: 'var(--bg-tag-grey)',
            }}
          >
            <Images.SparkleSmall width={56} height={43} />
          </AgxSpacer>
          <AgxSpacer direction="vertical" gap="xs">
            <AgxSpacer direction="horizontal" contentAlignment="center" gap="spacing-lg">
              <AgxTypography id="title" type="heading" size="x-large" color="var(--text-primary)">
                {contract.contractName}
              </AgxTypography>
              <AgxBadge
                text={contractStage}
                type={
                  contract.contractStage === QldContractStage.BackUp
                    ? AgxBadgeType.Finished
                    : getContractStageBadgeType(
                        contract.contractStage as QldContractStage | NswContractStage
                      )
                }
              />
            </AgxSpacer>

            <AgxSpacer direction="horizontal" contentAlignment="center" gap="spacing-md" wrap>
              {buyerNames && (
                <>
                  <AgxTypography id="contract-buyers" type="body_ui" size="small">
                    {buyerNames}
                  </AgxTypography>
                  <span
                    style={{
                      flex: '0 0 auto',
                      width: 4,
                      height: 4,
                      borderRadius: '50%',
                      background: 'var(--text-tertiary)',
                    }}
                  />
                </>
              )}
              {contract.salePrice && (
                <>
                  <AgxTypography id="contract-sale-price" type="body_ui_strong" size="small">
                    {formatCurrency(contract.salePrice)}
                  </AgxTypography>
                  <span
                    style={{
                      flex: '0 0 auto',
                      width: 4,
                      height: 4,
                      borderRadius: '50%',
                      background: 'var(--text-tertiary)',
                    }}
                  />
                </>
              )}
              <AgxTypography
                id="contract-last-update"
                type="body_ui"
                size="small"
                color="var(--text-tertiary)"
              >
                Updated {dayjs(contract.lastUpdate).format('D MMM YYYY')}
              </AgxTypography>
            </AgxSpacer>
          </AgxSpacer>
        </AgxSpacer>
      </AgxSpacer>
    </section>
  );
};

export default ContractSectionHeader;
